import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const SECTIONS = [
  { id: 'request', label: 'Parça Talebi',  icon: '📋' },
  { id: 'stock',   label: 'Parça Stoku',   icon: '🔍' },
  { id: 'after',   label: 'Sonraki Adımlar', icon: '💬' },
];

const Step = ({ n, title, desc, tip }) => (
  <div className="flex gap-5 items-start">
    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-700 text-white text-sm font-bold flex items-center justify-center shadow-sm">{n}</div>
    <div className="pt-1">
      <h4 className="text-base font-semibold text-gray-900 mb-1">{title}</h4>
      <p className="text-gray-500 text-sm leading-relaxed mb-1">{desc}</p>
      {tip && <p className="text-xs text-blue-600 bg-blue-50 border border-blue-100 rounded-lg px-3 py-1.5 inline-block mt-1">💡 {tip}</p>}
    </div>
  </div>
);

export default function HowItWorksPage() {
  const navigate = useNavigate();
  const [active, setActive] = useState('request');

  return (
    <div className="min-h-screen bg-white"><Navbar />

      {/* Hero */}
      <div className="bg-gradient-to-br from-gray-900 to-blue-900 pt-24 pb-14 px-4 sm:px-6 text-center">
        <span className="inline-block bg-blue-700 text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wide">Rehber</span>
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3">OtoParçamıBul Nasıl Çalışır?</h1>
        <p className="text-white/70 text-base max-w-xl mx-auto leading-relaxed">
          Araç parçası bulmak hiç bu kadar kolay olmamıştı. Adım adım rehberimizle dakikalar içinde başlayın.
        </p>
      </div>

      {/* Tab nav */}
      <div className="sticky top-[68px] z-30 bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex">
            {SECTIONS.map(s => (
              <button key={s.id} onClick={() => setActive(s.id)}
                className={`flex-1 flex items-center justify-center gap-2 py-4 text-sm font-semibold border-b-2 transition
                  ${active === s.id ? 'border-blue-700 text-blue-700' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>
                <span>{s.icon}</span>
                <span className="hidden sm:inline">{s.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">

        {/* ── SECTION 1: Parts Request ── */}
        {active === 'request' && (
          <div>
            <div className="mb-10">
              <span className="text-blue-700 text-xs font-semibold uppercase tracking-widest">Bölüm 1</span>
              <h2 className="text-2xl font-bold text-gray-900 mt-1 mb-2">Parça Talebi Nasıl Oluşturulur?</h2>
              <p className="text-gray-500 text-sm leading-relaxed max-w-2xl">
                OtoParçamıBul'da parça talebi oluşturmak ücretsiz ve çok kolaydır. Talebiniz saniyeler içinde tedarikçilere iletilir.
              </p>
            </div>

            <div className="space-y-8 mb-10">
              <Step n="1" title="Araç Bilgilerinizi Girin"
                desc="Marka, model ve üretim yılını seçin. Şasi numaranız varsa otomatik doldurma özelliğini kullanabilirsiniz — sadece şasi numaranızı yazın ve araç bilgileri anında doldurulur."
                tip="Şasi (VIN) numaranız ruhsat belgenizde veya ön camın alt köşesindedir." />
              <Step n="2" title="Parçayı Seçin"
                desc="Kategori → Alt Kategori → Parça adı sırasıyla seçin. Örneğin: Fren Sistemi → Diskler & Balatalar → Fren Diski Ön. Seçtikten sonra OEM numarası veya ek açıklama ekleyebilirsiniz."
                tip="OEM numarasını biliyorsanız ekleyin — tedarikçiler çok daha hızlı yanıt verir." />
              <Step n="3" title="İletişim Bilgilerinizi Girin"
                desc="Ad soyad, telefon ve e-posta adresinizi girin. Teklifler e-posta adresinize iletilecektir."
                tip="Hesap oluşturarak tüm taleplerinizi ve tekliflerinizi tek ekranda takip edebilirsiniz." />
              <Step n="4" title="Talebi Gönderin"
                desc="'Talebi Gönder' butonuna tıklayın. Talebiniz anında onaylı tedarikçilere iletilir. Teklif geldiğinde e-posta ile haberdar edilirsiniz."
                tip={null} />
            </div>

            {/* Info box */}
            <div className="grid sm:grid-cols-3 gap-4 mb-8">
              {[
                { icon:'⚡', title:'Anında İletilir',   desc:'Talebiniz saniyeler içinde tedarikçilere ulaşır' },
                { icon:'💰', title:'Teklifleri Karşılaştırın', desc:'Birden fazla tedarikçiden fiyat alın' },
                { icon:'🔒', title:'Ücretsiz & Güvenli', desc:'Talep oluşturmak tamamen ücretsiz' },
              ].map(i => (
                <div key={i.title} className="bg-blue-50 border border-blue-100 rounded-xl p-4 text-center">
                  <div className="text-2xl mb-2">{i.icon}</div>
                  <p className="text-sm font-semibold text-blue-800">{i.title}</p>
                  <p className="text-xs text-blue-600 mt-1">{i.desc}</p>
                </div>
              ))}
            </div>

            <button onClick={() => navigate('/request')}
              className="bg-blue-700 hover:bg-blue-800 text-white font-semibold px-8 py-3 rounded-xl text-sm transition">
              Parça Talebi Oluştur →
            </button>
          </div>
        )}

        {/* ── SECTION 2: Parts Stock ── */}
        {active === 'stock' && (
          <div>
            <div className="mb-10">
              <span className="text-blue-700 text-xs font-semibold uppercase tracking-widest">Bölüm 2</span>
              <h2 className="text-2xl font-bold text-gray-900 mt-1 mb-2">Parça Stoku Nasıl Aranır?</h2>
              <p className="text-gray-500 text-sm leading-relaxed max-w-2xl">
                Parça stokunda 5 farklı arama yöntemiyle ihtiyacınız olan parçaya ulaşabilirsiniz.
              </p>
            </div>

            {/* Search methods */}
            <div className="grid sm:grid-cols-2 gap-4 mb-10">
              {[
                { icon:'🚗', title:'Marka ile Arama',         desc:'Araç markası, modeli ve üretim yılını seçin. Ardından parça kategorisi ve parça adını belirtin.' },
                { icon:'🔢', title:'OEM / Artikel Numarası',   desc:'Parçanın OEM numarasını biliyorsanız en kesin sonucu bu yöntemle alırsınız.' },
                { icon:'⚙️', title:'Motor Kodu',              desc:'Motor kodunuzla motora özel uyumlu parçaları bulun. Motor bloğu üzerinde yazar.' },
                { icon:'🔧', title:'Şanzıman Kodu',           desc:'Şanzıman kodu ile tam uyumlu parça arayın. Şanzıman gövdesinde veya belgelerinizde bulunur.' },
                { icon:'🔖', title:'Şasi No (VIN)',            desc:'17 karakterli şasi numaranızla araç bilgilerinizi eşleştirin ve uyumlu parçaları görün.' },
              ].map(m => (
                <div key={m.title} className="flex gap-4 p-4 bg-white border border-gray-100 rounded-xl shadow-sm hover:border-blue-200 transition">
                  <span className="text-2xl flex-shrink-0">{m.icon}</span>
                  <div>
                    <h4 className="text-sm font-semibold text-gray-900 mb-1">{m.title}</h4>
                    <p className="text-xs text-gray-500 leading-relaxed">{m.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Part condition guide */}
            <div className="bg-gray-50 border border-gray-100 rounded-2xl p-6 mb-8">
              <h3 className="text-base font-semibold text-gray-900 mb-4">Parça Durumu Ne Anlama Gelir?</h3>
              <div className="space-y-3">
                {[
                  { dot:'bg-green-500', title:'Orijinal (OEM)', desc:'Araç üreticisinin orijinal parçası. En yüksek kalite ve uyumluluk garantisi. Fiyat genellikle daha yüksektir.' },
                  { dot:'bg-blue-500',  title:'Muadil',         desc:'Orijinal ile aynı kalite standartlarında üretilmiş alternatif parça. Genellikle daha uygun fiyatlıdır.' },
                  { dot:'bg-amber-500', title:'Çıkma / 2. El',  desc:'Başka araçtan sökülen, kullanılmış parça. Bütçe dostu seçenek — tedarikçiden detay isteyin.' },
                ].map(c => (
                  <div key={c.title} className="flex gap-3 items-start">
                    <span className={`w-3 h-3 rounded-full ${c.dot} mt-1 flex-shrink-0`} />
                    <div>
                      <span className="text-sm font-semibold text-gray-800">{c.title} — </span>
                      <span className="text-sm text-gray-500">{c.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button onClick={() => navigate('/stock')}
              className="bg-blue-700 hover:bg-blue-800 text-white font-semibold px-8 py-3 rounded-xl text-sm transition">
              Parça Stokuna Git →
            </button>
          </div>
        )}

        {/* ── SECTION 3: After Request ── */}
        {active === 'after' && (
          <div>
            <div className="mb-10">
              <span className="text-blue-700 text-xs font-semibold uppercase tracking-widest">Bölüm 3</span>
              <h2 className="text-2xl font-bold text-gray-900 mt-1 mb-2">Talep Sonrası Ne Olur?</h2>
              <p className="text-gray-500 text-sm leading-relaxed max-w-2xl">
                Talebinizi gönderdikten sonra süreç şu şekilde işler.
              </p>
            </div>

            <div className="space-y-6 mb-10">
              {[
                { n:'01', title:'Tedarikçiler Talebinizi Görür',   desc:'Talebiniz anında onaylı tedarikçilere iletilir. Tedarikçiler kendi panellerinde talebinizi görür ve stok kontrol eder.' },
                { n:'02', title:'Teklifler Gelmeye Başlar',         desc:'Uygun stoku olan tedarikçiler fiyat, parça durumu (orijinal/muadil) ve teslimat süresiyle birlikte teklif gönderir. Teklifler e-posta ile size iletilir.' },
                { n:'03', title:'Teklifleri Karşılaştırın',         desc:'Hesabınıza giriş yaparak tüm teklifleri yan yana görebilirsiniz. Fiyat, tedarikçi puanı, konum ve teslimat süresine göre karşılaştırın.' },
                { n:'04', title:'Tedarikçiyle İletişime Geçin',     desc:'Seçtiğiniz tedarikçiyle platform üzerinden doğrudan mesajlaşabilirsiniz. Fotoğraf, teknik detay veya ek bilgi talep edebilirsiniz.' },
                { n:'05', title:'Güvenle Ödeyin',                   desc:'Teklifi kabul edin ve iyzico ile ödeyin. Ödemeniz, parçayı teslim aldığınızı onaylayana kadar güvencede tutulur; sorun olursa iade talebi açabilirsiniz. Sipariş ve teslimat bilgileri hesabınızda kayıtlı kalır.' },
              ].map(s => (
                <div key={s.n} className="flex gap-5 p-5 bg-white border border-gray-100 rounded-2xl shadow-sm hover:border-blue-100 transition items-start">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-700 text-white text-sm font-bold flex items-center justify-center">{s.n}</div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-900 mb-1">{s.title}</h4>
                    <p className="text-sm text-gray-500 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Messaging feature highlight */}
            <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6 mb-8">
              <h3 className="text-base font-semibold text-blue-900 mb-3 flex items-center gap-2">
                <span>💬</span> Platform İçi Mesajlaşma
              </h3>
              <p className="text-sm text-blue-700 mb-4 leading-relaxed">
                Hesabınız üzerinden tedarikçilerle güvenli mesajlaşabilirsiniz. Fotoğraf gönderin, teknik detay sorun, fiyat müzakeresi yapın — hepsi tek bir yerde.
              </p>
              <div className="grid sm:grid-cols-3 gap-3">
                {[
                  ['📷','Fotoğraf Gönder','Parça fotoğrafı veya hasarı gösterin'],
                  ['🔔','Anlık Bildirim','Yeni teklif geldiğinde anında haberdar olun'],
                  ['📁','Geçmiş Kayıtlı','Tüm talepler ve teklifler hesabınızda saklanır'],
                ].map(([icon, title, desc]) => (
                  <div key={title} className="bg-white border border-blue-100 rounded-xl p-3 text-center">
                    <div className="text-xl mb-1">{icon}</div>
                    <p className="text-xs font-semibold text-blue-800">{title}</p>
                    <p className="text-xs text-blue-600 mt-0.5">{desc}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* FAQ */}
            <div className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden">
              <div className="px-6 py-4 border-b border-gray-100">
                <h3 className="text-base font-semibold text-gray-900">Sık Sorulan Sorular</h3>
              </div>
              {[
                ['Talep oluşturmak ücretsiz mi?',             'Evet, tamamen ücretsizdir. Hiçbir ücret ödemeden istediğiniz kadar talep oluşturabilirsiniz.'],
                ['Kaç teklif alabilirim?',                    'İlgilenebilecek tüm onaylı tedarikçilerden teklif alabilirsiniz. Teklif sayısı parçaya ve bölgeye göre değişir.'],
                ['Bilgilerimin güvenliği nasıl sağlanır?',    'Tüm veriler şifreli (HTTPS) iletilir. Kişisel bilgileriniz 3. şahıslarla paylaşılmaz.'],
                ['Tedarikçiler güvenilir mi?',                'Tedarikçiler kayıt sırasında vergi levhasını yükler ve hesapları ekibimizce onaylanır. Belgesi kontrol edilen satıcılar "Doğrulanmış satıcı" rozetiyle gösterilir. Kullanıcı puanları gerçek deneyimlere dayanır.'],
                ['Teklif aldıktan sonra satın almak zorunlu mu?', 'Hayır. Teklif almak hiçbir yükümlülük doğurmaz. İstediğiniz teklifi seçebilir veya reddedebilirsiniz.'],
              ].map(([q, a]) => (
                <div key={q} className="px-6 py-4 border-b border-gray-50 last:border-0">
                  <p className="text-sm font-semibold text-gray-800 mb-1">❓ {q}</p>
                  <p className="text-sm text-gray-500">{a}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Bottom CTA */}
      <div className="bg-gray-900 py-14 px-4 sm:px-6 text-center">
        <h2 className="text-2xl font-bold text-white mb-3">Hemen Başlayın — Ücretsiz</h2>
        <p className="text-gray-400 text-sm mb-7 max-w-md mx-auto">Araç parçanızı dakikalar içinde bulun. Kayıt gerektirmez.</p>
        <div className="flex gap-4 justify-center flex-wrap">
          <button onClick={() => navigate('/request')} className="bg-blue-700 hover:bg-blue-800 text-white font-semibold px-7 py-3 rounded-xl text-sm transition">Parça Talebi Oluştur</button>
          <button onClick={() => navigate('/stock')} className="border border-gray-600 text-gray-300 hover:border-gray-400 font-semibold px-7 py-3 rounded-xl text-sm transition">Parça Stokuna Bak</button>
        </div>
      </div>

      <Footer />
    </div>
  );
}